<template>
  <v-select
    dense
    :id="field.id"
    :name="field.name"
    :items="field.choices"
    :label="field.label"
    :required="field.required"
    :rules="field.required && [rules.required] || []"
    :value="field.value"
    v-model="selected"
  >
  </v-select>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'DependingProcessSelectComponent',
  props: {
    field: {
      type: Object,
      default: function () {
        return {}
      }
    },      
  },  
  data() {
    return {      
      rules: {
          required: v => !!v || 'Field is mandatory'
      },
      selected: null
    }
  },
//   watch:{
//     // if process change reload depending components
//     form_process: function(newVal, oldVal) {
//       this.getChoices()
//     }
//   },
  methods: {
    getChoices(){
      console.log('getChoices Child')
      console.log(this.field)
      this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/unitwidget/get_process_depending_users/?permission_id=' + this.field.permission_id + '&process_id=' + this.form_process)
        .then(response => {
          this.field.choices = response.data
          this.field.value = ''
          this.selected = ''
        })
        .catch(err => {
//            this.loading = false
          alert(err)
        })    
    },  
  },
  updated() {
    console.log('Child updated', this.field, this.selected)
    if (this.field.choices.length==0) this.selected = ''
  },
  computed: {
    ...mapState([
      'form_process',
    ]), 
  },

}
</script>
